import { Skeleton, Stack } from '@backyard-ui/core';

function Items() {
  return (
    <Stack direction="column" data-testid="items-skeleton">
      <Skeleton width="208px" height="16px" />
      <Skeleton width="320px" height="16px" />
      <Skeleton width="176px" height="16px" />
    </Stack>
  );
}
export default Items;
